export const NoPhoneFound = () => {
  return (
    <div className="h-screen flex items-center justify-center px-8 text-center">
      <h1 className="text-coco-black font-semibold">
        There's no orders found for this phone number
      </h1>
    </div>
  );
};
